import style from "./style.module.css"
const DefaultLoading = () => {
    return (
        <div className={style.spinnerWrapper}>
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default DefaultLoading;